<template>
    <div>
        <div
            v-for="context in grouped"
            :key="context.group.id"
        >
            <div
                class="group-name flex-con xs-pad-lr is-grow has-cursor-pointer"
                @click="toggleCollapse(context.group.id)"
            >
                <div class="is-narrow">
                    <i
                        class="fa"
                        :class="!isCollapsed(context.group.id) ?  'fa-folder-open-o' : 'fa-folder-o'"
                    ></i>
                </div>
                <div class="heading">
                    {{context.group.name}}
                </div>
            </div>
            <div
                class="filters items"
                v-show="!isCollapsed(context.group.id)"
            >
                <div
                    v-for="filterContext in context.filters"
                    :key="filterContext.id"
                    class="item"
                    :class="{ 'active' : selectedIds.indexOf(filterContext.id) !== -1 }"
                    @click="select($event, filterContext)"
                >
                    {{filterContext.filter.name}}
                </div>
            </div>
        </div>
        <div
            v-for="filterContext in noGroup"
            :key="filterContext.id"
            class="item"
            :class="{ 'active' : selectedIds.indexOf(filterContext.id) !== -1 }"
            @click="select($event, filterContext)"
        >
            {{filterContext.filter.name}}
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
export default {
    name : "FilterList",
    props : {
        vuexStoreKey : {
            type : String,
            required : true,
        },
        selected : {
            type : Array,
            required : true,
        },
    },
    computed : {
        grouped () {
            const groups = [];
            _.each(this.$store.state[this.vuexStoreKey].groups, group => {
                groups.push({
                    group : group,
                    filters : _.where(this.$store.state[this.vuexStoreKey].filters, { accountSearchFilterGroupId : group.id }),
                });
            });
            return _.reject(groups, context => { return !context.filters.length });
        },
        noGroup () {
            return _.where(this.$store.state[this.vuexStoreKey].filters, { accountSearchFilterGroupId : null });
        },
        selectedIds () {
            return _.pluck(this.selected, 'id');
        },
    },
    methods : {
        isCollapsed (groupId) {
            return this.$store.state.searchGroupCollapseState[`search_group:${groupId}`];
        },
        toggleCollapse (groupId) {
            this.$store.commit('setSearchGroupCollapse', { uniqueId : `search_group:${groupId}`, collapsed : !this.isCollapsed(groupId) });
            this.$emit('toggle-collapsed');
        },
        select (event, filter) {
            this.$emit('selected', { filter : filter, addToSelection : event.ctrlKey || event.metaKey });
        },
    },
}
</script>

<style lang="scss" scoped>

    @import '../../../assets/css/_theme';

    .group-name {
        color:$grey;
        .heading {
            margin-bottom:0;
        }
    }
    .filters {
        margin-left:22px;
    }

</style>
